import { render, staticRenderFns } from "./eAristoQuestionStudentQuizIndex.vue?vue&type=template&id=4e73b216&scoped=true"
import script from "./eAristoQuestionStudentQuizIndex.vue?vue&type=script&lang=js"
export * from "./eAristoQuestionStudentQuizIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e73b216",
  null
  
)

export default component.exports